var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGlobe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 12a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9 12a14.3 14.3 0 0 0 3 8.45A14.3 14.3 0 0 0 15 12a14.3 14.3 0 0 0-3-8.45A14.3 14.3 0 0 0 9 12m3-10-.74-.67A16.3 16.3 0 0 0 7 12.03a16.3 16.3 0 0 0 4.26 10.64 1 1 0 0 0 1.48 0A16.3 16.3 0 0 0 17 11.97a16.3 16.3 0 0 0-4.26-10.64z",
  clipRule: "evenodd"
})));
export default SvgIcGlobe;